import { MedicationsEntity } from '../store/types/prescription';
import { FETCH_DRUGS_SUBSTITUTE } from './constants';
import { Drugs } from './fetchDrugsAndLabTestsStatus';
import fetchWithRefresh from './fetchWithRefresh';

interface Request {
    pincode: string;
    patient_id: string;
    medications: MedicationsEntity[];
}

interface Response {
    success: boolean;
    substituteArray: SubstitutesResponse;
    statusObject: Drugs;
}

export type SubstitutesResponse = DrugSubstitutesResponse[];

export type DrugSubstitutesResponse = [Medicine, CodedMedicine[]];

export interface Medicine {
    name: string;
    eka_id: string;
    form: string;
    qty: string;
    unit: string;
    unit_ekaid: string;
    generic_name: string;
    generic_id: string;
    generic_composition_id: string;
}

export type CodedMedicine = {
    eka_id: string;
    mdb_qty: number;
    sku_id: string;
    pack_quantity: number;
    pack_form: string;
    pack_qty_label: string;
    name: string;
    manufacturer_name: string;
    generic_name: string;
    generic_id: string;
    generic_composition_id: string;
    drug_form: string;
    status: string;
    vendor_id: string;
    error_code: string;
    type: string;
    fare_dict: FareDict;
    reason?: string;
    vendor: string;
    product_type: string;
    dosage: {
        df_id?: string;
        unit?: string;
        unit_val?: string;
        unit_id?: string;
        unit_name?: string;
        dosage?: string;
        dosage_form?: string;
        days?: string;
        food?: string;
    };
    soa: boolean;
    index: number;
};

type FareDict = {
    gross_amt: number;
    discount_percent: number;
    discount_amount: number;
    net_amount: number;
};

export default (docid: string, request: Request): Promise<Response> => {
    return fetchWithRefresh(FETCH_DRUGS_SUBSTITUTE(docid), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
};
